import { type BaseApiErrorResponse, HttpStatus } from '../types/api.types';
import BaseApiResponseError from './BaseApiResponseError';

export type UnauthorizedErrorArgs<TErrors> = Omit<
  BaseApiErrorResponse<TErrors>,
  'errors' | 'status'
>;
export default class UnauthorizedError<
  TErrors,
> extends BaseApiResponseError<TErrors> {
  constructor({ message }: UnauthorizedErrorArgs<TErrors>) {
    super({ errors: null, message, status: HttpStatus.Unauthorized });
  }
}
